import Cookies from "js-cookie";

export abstract class Api<T> {
  private url;
  constructor(resource?: string) {
    this.url = process.env.REACT_APP_API_BASE_URL + "/api" + (resource || "");
  }

  async get(id: string, param?: string) {
    return this.buildQuery("GET", id + (param || ""));
  }
  async getAll(path?: string, param?: string) {
    return this.buildQuery("GET", param ? `${path || ""}?${param}` : path);
  }

  async post(payload: Partial<T>, path = "") {
    return this.buildQuery("POST", path, payload);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async put(id: string, payload?: any) {
    return this.buildQuery("PUT", id, payload);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async delete(id?: string, payload?: any) {
    return this.buildQuery("DELETE", id, payload);
  }

  private buildQuery = async (
    method?: string,
    suffix?: string,
    data?: Partial<T>,
  ) => {
    const token = Cookies.get("token");

    const headers: Record<string, string> = {
      Accept: "application/json",
    };

    const isFormData = data instanceof FormData;
    if (!isFormData) {
      headers["Content-Type"] = "application/json";
    }

    // set authentication header
    if (token) {
      headers["Authorization"] = "Bearer " + token;
    }

    const options: RequestInit = {
      method,
      headers,
    };
    if (!method || method !== "GET") {
      options.body = isFormData ? data : JSON.stringify(data || {});
    }

    // @TODO
    // modify response/error
    return fetch(this.getFullUrl(suffix), {
      ...options,
    })
      .then(async (res) => {
        const response = await res.json();

        if (res.ok) {
          return { data: response, status: true };
        }
        if (res.status === 401) {
          Cookies.remove("token");
        }
        throw {
          error:
            response ||
            new Error(response?.message || "Something went wrong.!"),
          status: false,
        };
      })
      .catch((err) => {
        throw err;
      });
  };

  private getFullUrl = (suffix?: string) =>
    this.url + (suffix ? `/${suffix}` : "");
}
